/*
 * Copyright (c) 2021. CodeGen Ltd. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by prabash on 5/07/2021.
 */
import grabPnrOperations from './grab-pnr-operations.json';

const PermissionKeys = {
  MBI_FLT_GRAB_PNR: 'SURF_MBI_FLT_GRAB_PNR',
  FLT_GRAB_PNR: 'SURF_FLT_GRAB_PNR',
  SURF_FLIGHT_CARD_REFRESH_PNR: 'SURF-FLIGHT-CARD_REFRESH-PNR',
  MBI_FLIGHT_SEARCH_REFRESH_PNR: 'SURF_MBI_FLIGHT_SEARCH_REFRESH_PNR'
};

const exportPnrOperations = () => {
  return grabPnrOperations;
};

export { PermissionKeys, exportPnrOperations };
